var exports = {
  "az": "Box__wO1jqt",
  "wy": "Box_1__NgV1zw",
  "PA": "Truncate__yEZaER",
  "EY": "Text__O8RCst",
  "s8": "PrimerLink__nNqLEU",
  "Dg": "Truncate_1__fzkDk_",
  "c4": "PrimerLink_1__bmR2Xe",
  "UE": "Text_1__R8OSuB",
  "m_": "Tooltip__PgvOLp",
  "Xp": "codeOwnerAccent__ERI5QP",
  "Dv": "overlayPortalRoot__wozMDP",
};

module.exports = exports;
